import cn from "classnames";
import React, { useRef } from "react";
import { NavLink } from "react-router-dom";

import PopoverOverlay from "../../../../components/UI/_TODO/PopoverOverlay/PopoverOverlay";

import styles from "./index.module.scss";

interface MenuItemProps {
  isExists?: boolean;
  link?: string;
  title: string;
  icon?: string;
  jsxIcon?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  exact?: boolean;
  isDirectlyActive?: boolean;
  isBottom?: boolean;
  isWithoutUnderline?: boolean;
  isTooltipHidden?: boolean;
  isWithIndicator?: boolean;
  onClick?: () => void;
}

const MenuItem = React.forwardRef<HTMLDivElement, MenuItemProps>(
  (
    {
      isExists = true,
      link,
      title,
      icon,
      jsxIcon,
      className = "",
      exact = false,
      isDirectlyActive,
      isBottom = false,
      isWithoutUnderline = false,
      onClick,
      children,
      isTooltipHidden,
      isWithIndicator = false,
    },
    ref
  ) => {
    const linkRef = useRef<HTMLAnchorElement | null>(null);

    const Content = React.memo(() => (
      <div
        className={cn(
          styles.container,
          {
            [styles.bottom]: isBottom && !isWithoutUnderline,
            [styles.left]: !isBottom && !isWithoutUnderline,
            [styles.withIndicator]: isWithIndicator,
          },
          className
        )}
        data-testid={`nav_${title}`}
        onClick={onClick}
        ref={ref}
      >
        {jsxIcon ? jsxIcon : <img src={icon} alt={title} className={cn(styles.icon)} />}
        {children}
      </div>
    ));

    if (!isExists) return null;

    return (
      <PopoverOverlay
        // Скрываем tooltip только когда явно указан isTooltipHidden = true
        isOpen={isTooltipHidden === true ? !isTooltipHidden : undefined}
        openType="hover"
        placement={isBottom ? "bottom" : "right"}
        popoverBorderColor={"primary"}
        portalClassName={cn(styles.tooltipPortal, {
          [styles.isRightPortal]: !isBottom,
          [styles.isBottomPortal]: isBottom,
        })}
        content={
          <div className={styles.tooltip} onClick={() => linkRef?.current?.click?.() || onClick?.()}>
            {title}
          </div>
        }
      >
        {link ? (
          <NavLink
            to={link}
            activeClassName={styles.active}
            exact={exact}
            className={cn({ [styles.active]: isDirectlyActive })}
            ref={linkRef}
          >
            <Content />
          </NavLink>
        ) : (
          <Content />
        )}
      </PopoverOverlay>
    );
  }
);

export default React.memo(MenuItem);
